"use client";

/**
 * The name of an icon-only button, revealed on hover.
 *
 * The rail's header is three unlabelled glyphs in a row, which is fine once you
 * know them and opaque until you do. A `title` attribute would technically
 * answer that, but it waits a second, renders in the OS's chrome rather than
 * the app's, and never appears for keyboard users at all — so this is a real
 * element instead: instant, themed, and shown on focus as well as hover.
 *
 * Purely decorative to assistive tech (`aria-hidden`) — the button it labels
 * already carries the same text as its `aria-label`, and announcing it twice
 * would be worse than not announcing it.
 *
 * Requires the positioned ancestor to carry Tailwind's `group relative`.
 */
export default function HoverLabel({ children }: { children: string }) {
  return (
    <span
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-full z-50 mt-1.5 -translate-x-1/2 translate-y-0.5 whitespace-nowrap rounded-md border border-sky-900/70 bg-ocean-900/95 px-2 py-1 text-[10.5px] font-medium leading-none text-sky-200 opacity-0 shadow-lg backdrop-blur transition duration-150 group-hover:translate-y-0 group-hover:opacity-100 group-focus-within:translate-y-0 group-focus-within:opacity-100"
    >
      {children}
    </span>
  );
}
